import { PaymentResult } from 'shared/api/BuyTicketModel'
import { callMBankBridge } from 'shared/lib/mbank-bridge'
import { MBANK_BRIDGE_ERROR_MESSAGE } from 'shared/lib/mbank-bridge/constants'

export const startPaymentFromConfirmResult = async (
  paymentResult: PaymentResult,
  { allowDisabledFallback = true }: { allowDisabledFallback?: boolean } = {},
): Promise<boolean> => {
  const response = await callMBankBridge('payment.start', {
    serviceId: paymentResult.paymentTreeServiceId,
    code: paymentResult.paymentCode,
    amount: paymentResult.totalAmount,
    resultUrl: paymentResult.resultUrl,
    parameters: paymentResult.parameters ?? {},
  })

  if (response.ok) return true

  if (
    allowDisabledFallback &&
    response.error.message === MBANK_BRIDGE_ERROR_MESSAGE.DISABLED
  ) {
    return true
  }

  return false
}
